import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f0f0f0;
  font-family: 'Comic Sans MS', cursive;
`;

const Title = styled.h1`
  font-size: 48px;
  color: #333;
  margin-bottom: 40px;
`;

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  max-width: 1000px;
  width: 100%;
  gap: 20px;
  padding: 0 20px;

  @media (min-width: 1000px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const StyledButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  background: #a13b16;
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background: #8b2f0f;
  }
`;

const Admin: React.FC = () => {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <Title>Сторінка Адміністратора</Title>
      <ButtonsContainer>
        <StyledButton onClick={() => navigate("/admin/authors")}>Автори</StyledButton>
        <StyledButton onClick={() => navigate("/admin/books")}>Книги</StyledButton>
        <StyledButton onClick={() => navigate("/admin/genres")}>Жанри</StyledButton>
        <StyledButton onClick={() => navigate("/admin/orders")}>Замовлення</StyledButton>
        <StyledButton onClick={() => navigate("/admin/news")}>Новини</StyledButton>
        <StyledButton onClick={() => navigate("/admin/formats")}>Формати</StyledButton>
        <StyledButton onClick={() => navigate("/admin/languages")}>Мови</StyledButton>
        <StyledButton onClick={() => navigate("/admin/publishers")}>Видавництва</StyledButton>
        <StyledButton onClick={() => navigate("/admin/cover-types")}>Обкладинки</StyledButton>
        <StyledButton onClick={() => navigate("/admin/tables")}>Tables</StyledButton>
      </ButtonsContainer>
    </PageContainer>
  );
};

export default Admin;
